import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import SecondLevel from '../views/SecondLevel.vue'
import { getCookie } from '../utils/cookei'

const routes: Array<RouteRecordRaw> = [
    {
        path: '/home',
        name: 'home',
        component: HomeView
    },
    // {
    //     path: '/about',
    //     name: 'about',
    //     component: () => import('../views/AboutView.vue')
    // },
    {
        path: '/',
        name: 'secondLevel',
        component: SecondLevel
    }
]

// 创建路由实例 不使用历史模式
const router = createRouter({
  history: createWebHashHistory(),
  routes
})

router.beforeEach((to, from, next) => {
    let loginTypeName = ''
    if (to.query.loginTypeName) {
        loginTypeName = to.query.loginTypeName as string
        localStorage.setItem('loginTypeName', loginTypeName)
    } 
    // 白名单路由，不需要验证token
    const whiteList = ['/']
    if (whiteList.includes(to.path)) {
        next()
        return
    }
    const tokenname = getCookie('Token');
    if (tokenname) {
        // token 存在，判断用户类型，非个人用户
        next();
    } else {
        // token 不存在，重定向到首页
        next('/');
    }
})

router.afterEach((to:any) => {
    // 如果URL中存在loginTypeName参数，且已经保存到localStorage，则清除URL中的参数
    if (to.query.loginTypeName && localStorage.getItem('loginTypeName')) {
        const newQuery = { ...to.query };
        delete newQuery.loginTypeName;
        router.replace({
            path: to.path,
            query: newQuery
        });
    }
});


export default router
